import { render } from "./ProfileImage.vue?vue&type=template&id=1c845542&scoped=true&ts=true"
import script from "./ProfileImage.vue?vue&type=script&lang=ts"
export * from "./ProfileImage.vue?vue&type=script&lang=ts"

import "./ProfileImage.vue?vue&type=style&index=0&id=1c845542&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c845542"]])

export default __exports__